import React from "react";
// import Faq from "../../FAQ/faq";
import { useNavigate } from "react-router-dom";

const SolarEVehicle = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/contact");
  };
  return (
    <>
      <div
        className="w-full flex justify-center items-center text-white font-bold px-4 bg-cover bg-center min-h-[220px] md:min-h-[280px] py-10 md:py-16"
        style={{
          backgroundImage: `url(/banner.png)`,
        }}
      >
        <div className="text-center max-w-[95%] sm:max-w-[80%] md:max-w-[60%] px-2">
          <h1 className="text-brand-green text-3xl md:text-4xl font-bold sm:text-3xl md:text-7xl leading-snug sm:leading-normal">
            Embrace the Future of Sustainable Mobility
          </h1>
          <p className="text-sm sm:text-base md:text-lg mt-4 text-black leading-relaxed">
            `At Kyra Green Energy Solution, we are committed to driving the future of transportation with solar-powered electric vehicles (EVs). We provide sales, service, and integrated solar charging solutions for all leading EV brands, ensuring you make the most of both clean energy and efficiency.          </p>
        </div>
      </div>



      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold text-brand-green">
                Our Solar E-Vehicle Solutions
              </h2>
              <ul className="space-y-4 text-gray-700 mt-6">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>EV Sales &amp; Marketing:</strong> Access the latest electric
                    vehicle models designed for sustainability and performance.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Solar Charging Solutions:</strong> We integrate
                    solar-powered charging stations with your EV for cost-effective,
                    energy-efficient operation.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>EV Service &amp; Maintenance:</strong> Our expert team ensures
                    your solar-powered EVs and charging stations remain in top condition,
                    optimizing performance and lifespan.
                  </span>
                </li>
              </ul>

              <button
                className="mt-8 text-white px-8 py-3 rounded-lg bg-brand-green font-semibold hover:opacity-90 transition-colors"
                onClick={handleClick}
              >
                Learn More About Our EV Solutions
              </button>
            </div>
            <div className="flex justify-center">
              <div className="">
                <img
                  src="/white-green-nov-scooter-charging.png"
                  alt="Green electric scooter charging at station"
                  className=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-brand-green">
                Why Solar-Powered EVs?
              </h2>
              <p className="text-gray-700 mb-6">
                Kyra Green Energy Solution helps you reduce your carbon footprint
                while saving on energy costs through solar-powered electric vehicles.
                Here’s why solar EVs are the future of transportation:
              </p>
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Eco-Friendly Transportation:</strong> Powered by solar energy,
                    solar EVs help reduce pollution and support a greener planet.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Lower Operational Costs:</strong> Save on fuel and electricity
                    by charging your EV using solar energy.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Energy Independence:</strong> By integrating solar charging
                    with your EV, you become less reliant on the grid, ensuring reliable
                    power whenever you need it.
                  </span>
                </li>
              </ul>

              <button
                className="mt-8 text-white px-8 py-3 rounded-lg bg-brand-green font-semibold hover:opacity-90 transition-colors"
                onClick={handleClick}
              >
                Explore Our Solar EV Models
              </button>
            </div>
            <div className="flex justify-center">
              <div className="">
                <img
                  src="/black-red-scooter-charging.png"
                  alt="Black and red scooter charging at city station"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-8 text-brand-green">
                Why Kyra Green Energy For Your EV Needs?
              </h2>
              <ul className="space-y-4 text-gray-700">
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Complete EV Solutions:</strong> From sales and service to
                    solar charging, we provide everything you need for a sustainable
                    transportation future.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Trusted EV Brands:</strong> We work with top-tier electric
                    vehicle manufacturers, ensuring you get the best in performance and
                    design.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Seamless Integration:</strong> We make it easy to integrate
                    solar charging solutions with your electric vehicle, maximizing your
                    energy savings and reducing reliance on the grid.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="w-2 h-2 bg-green-primary rounded-full mt-2 mr-3 flex-shrink-0"></span>
                  <span>
                    <strong>Expert Support:</strong> From initial consultation to
                    long-term maintenance, we offer comprehensive support for all your
                    EV needs.
                  </span>
                </li>
              </ul>


              <button
                className="mt-8 text-white px-8 py-3 bg-brand-green rounded-lg font-semibold hover:opacity-90 transition-colors"
                onClick={handleClick}
              >
                Get Started Today
              </button>
            </div>
            <div className="flex justify-center">
              <div className="">
                <img
                  src="/white-green-scooter-charging.png"
                  alt="Person charging white and green scooter"
                // className="w-full h-62 object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <Faq type="evs" /> */}
    </>

  );
};

export default SolarEVehicle;
